module.exports = "<div class=\"overlay-state-con\">\n    <div class=\"overlay-state relative\"></div>\n</div>"